import { object, string } from 'yup';
import { CARD_NAME } from '../enum/Billing';

const personalInfoValidationSchema = object({
  [CARD_NAME]: string('Name is required').max(20).required('Name is required.'),
});

export default personalInfoValidationSchema;
